import { axios } from '@/utils/request'
import { isFunction } from 'ant-design-vue/lib/_util/vue-types/utils'

class LuckyAPIClass {
  _getList = '/61527e615402c'
  _getGoodsList = '/6152796f7e951'
  _getFreeList = '/615323193ea9d'
  _addLucky = '/615035b88d698'
  _addFree = '/61531fa456c65'
  _editLuckyStatus = '/615127058dc0c'
  _editLucky = '/61511946a8bef'
  _editLuckyGoods = '/61518c813698a'
  _getGoodsListById = '/615271a29e5c2'
  _addLuckyGoods = '/615173e9033e7'
  _delLuckyGoods = '/61527f0f13f51'
  _delGoods = '/61527f0f13f51'
  _delFree = '/615321ce986f4'
  _getConfig = '/61a73ae854b64'
  _saveConfig = '/61a6efe3535c3'

  getConfig(params) {
    return axios.get(this._getConfig, { params })
  }

  saveConfig(params) {
    return axios.post(this._saveConfig, params)
  }

  getList(params) {
    return this.toList(this._getList, params)
  }
  getFreeList(params) {
    return this.toList(this._getFreeList, params)
  }
  getGoodsListById(parameter) {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20
    })
    return axios.get(this._getGoodsList, { params })
  }
  getGoodsList(params) {
    return this.toList(this._getGoodsList, params)
  }
  addLucky(data) {
    return axios.post(this._addLucky, data)
  }
  addFree(data) {
    return axios.post(this._addFree, data)
  }
  addLuckyGoods(data) {
    return axios.post(this._addLuckyGoods, data)
  }
  editLucky(data) {
    return axios.post(this._editLucky, data)
  }
  editLuckyGoods(data) {
    return axios.post(this._editLuckyGoods, data)
  }
  editLuckyStatus(data) {
    return axios.post(this._editLuckyStatus, data)
  }
  delLuckyGoods(data) {
    return axios.post(this._delLuckyGoods, data)
  }
  delGoods(data) {
    return axios.post(this._delGoods, data)
  }
  delFree(data) {
    return axios.post(this._delFree, data)
  }

  toList(url, parameter, func) {
    let params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20
    })

    if (func && isFunction(func)) {
      params = func(params)
    }

    return axios.get(url, { params }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count
      }
    })
  }
}

export const LuckyAPI = new LuckyAPIClass()
